/* eslint-disable import/prefer-default-export */
export class HydrationError extends Error {
  constructor(message, options?) {
    super(message, options);
    this.name = 'Hydration Error';
  }
}
